export default "__VITE_ASSET__DyF00G0d__"